{
  "search": "Recherche",
  "completed": "Entreprise finalisée",
  "notCompleted": "Entreprise non finalisée",
  "types": {
    "CORPORATION": "Entreprise",
    "LLC": "Société à responsabilité limitée",
    "PARTNERSHIP": "Partenariat",
    "SOLE_PROPRIETORSHIP": "Entreprise individuelle"
  },
  "table": {
    "name": "Nom de l'entreprise",
    "primaryContact": "Contact principal",
    "primaryEmail": "Courriel du contact principal",
    "numberOfAccounts": "Nombre de comptes",
    "completedAt": "Terminé à ",
    "totalAssets": "Total des actifs",
    "organization": "Organisation"
  },
  "addModal": {
    "title": "Ajouter une nouvelle entreprise",
    "name": "Nom",
    "corporationType": "Type d'entreprise",
    "corporationCountry": "Pays",
    "createARelation": "Créer une relation",
    "primaryUser": "Utilisateur principal",
    "organization": "Organisation",
    "establishedDate": "Date d'établissement"
  },
  "tooltips": {
    "establishedDate": "Date d'établissement",
    "primaryEmail": "Courriel du contact principal",
    "physicalAddress": "Adresse"
  },
  "tabs": {
    "overview": "Aperçu",
    "details": "Détails",
    "affiliates": "Affiliés",
    "documents": "Documents",
    "statements": "Relevés",
    "transfers": "Virements",
    "ledger": "Grand livre",
    "trades": "Opérations",
    "notes": "Notes"
  },
  "overview": {
    "totalCorporationAssets": "Total des actifs de l'entreprise"
  },
  "details": {
    "accountInformation": "Renseignements sur le compte",
    "fees": "Frais",
    "contactInformation": "Coordonnées",
    "name": "Nom",
    "esablishedDate": "Date d'établissement",
    "country": "Pays",
    "address": "Adresse",
    "type": "Type",
    "incorporationNumber": "Nom de l'entreprise",
    "businessIsMemberOfIiroc": "L'entreprise est membre de l'OCRCVM",
    "taxNumber": "Numéro d'immatriculation à l'ARC",
    "email": "Courriel",
    "phone": "Numéro de téléphone",
    "feeGrid": "Grille tarifaire",
    "billingCycle": "Cycle de facturation"
  },
  "edit": {
    "accountInformation": "Renseignements sur le compte",
    "fees": "Frais",
    "contactInformation": "Coordonnées",
    "name": "Nom",
    "establishedDate": "Date d'établissement",
    "country": "Pays",
    "physicalAddress": "Adresse",
    "businessType": "Type",
    "incorporationNumber": "Nom de l'entreprise",
    "businessIsMemberOfIiroc": "L'entreprise est membre de l'OCRCVM",
    "taxNumber": "Numéro d'immatriculation à l'ARC",
    "feeTierId": "Grille tarifaire",
    "billingScheduleId": "Cycle de facturation",
    "primaryEmail": "Courriel",
    "phone": "Numéro de téléphone",
    "businessTypeOptions": {
      "CORPORATION": "Entreprise",
      "LLC": "Société à responsabilité limitée",
      "PARTNERSHIP": "Partenariat",
      "SOLE_PROPRIETORSHIP": "Entreprise individuelle"
    },
    "corporationCountry": "Pays de l'entreprise",
    "buttons": {
      "updateContactInformation": "Mettre à jour les coordonnées de l'entreprise",
      "updateFeesInformation": "Mettre à jour les renseignements financiers de l'entreprise",
      "updateAccountInformation": "Mettre à jour les coordonnées du compte"
    },
    "title": "Mettre à jour les renseignements de l'entreprise"
  }
}
